exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.ui-select svg {\n    width: 16px;\n    height: 16px;\n}\n\n", ""]);
